export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.authData.token) {
        return { 'Authorization': 'Bearer ' + user.authData.token };
    } else {
        return {};
    }
}